import { render, staticRenderFns } from "./CustomerCardInfomation.vue?vue&type=template&id=64a713d1"
import script from "./CustomerCardInfomation.vue?vue&type=script&lang=js"
export * from "./CustomerCardInfomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports